import { RouteHandles, Routes } from "@/app/routes.ts";
import ConversationPage from "@/app/routes/ConversationPage.tsx";
import HomePage from "@/app/routes/HomePage.tsx";
import { NotFoundErrorPage } from "@/app/routes/NotFoundErrorPage.tsx";
import PersonalizationPage from "@/app/routes/PersonalizationPage.tsx";
import SmartReportsEditPage from "@/app/routes/SmartReportsEditPage.tsx";
import SmartReportsListPage from "@/app/routes/SmartReportsListPage.tsx";
import { AppRoot } from "@/app/routes/root/AppRoot.tsx";
import { AuthenticationBoundary } from "@/app/routes/root/AuthenticationBoundary.tsx";
import { ErrorBoundary } from "@/app/routes/root/ErrorBoundary.tsx";
import { RootLayout } from "@/components/layouts/RootLayout.tsx";
import { createBrowserRouter, RouterProvider } from "react-router";

const router = createBrowserRouter([
    {
        element: <AppRoot />,
        children: [
            {
                element: <AuthenticationBoundary />,
                errorElement: <ErrorBoundary />,
                children: [
                    {
                        path: Routes.Home(),
                        element: <RootLayout />,
                        errorElement: <ErrorBoundary />,
                        children: [
                            {
                                index: true,
                                element: <HomePage />,
                                handle: RouteHandles.Home
                            },
                            {
                                path: Routes.Conversation(":conversationId"),
                                element: <ConversationPage />,
                                handle: RouteHandles.Conversation
                            },
                            {
                                path: Routes.Personalization(),
                                element: <PersonalizationPage />,
                                handle: RouteHandles.Personalization
                            },
                            {
                                path: Routes.SmartReports(),
                                element: <SmartReportsListPage />,
                                handle: RouteHandles.SmartReports
                            },
                            {
                                path: Routes.SmartReportsEdit(),
                                element: <SmartReportsEditPage />,
                                handle: RouteHandles.SmartReportsEdit
                            }
                        ]
                    },
                    {
                        path: "*",
                        element: <NotFoundErrorPage />
                    }
                ]
            }
        ]
    }
]);

export const AppRouter = () => {
    return (
        <RouterProvider router={router} />
    );
};
